module.exports = __webpack_public_path__ + "static/media/PhotoshopIcon.7210f399.svg";